import script from "./FaqIntentPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./FaqIntentPicker.vue?vue&type=script&lang=ts&setup=true"

import "./FaqIntentPicker.vue?vue&type=style&index=0&id=1c8c755e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c8c755e"]])

export default __exports__